<script setup>
  import { ref, onMounted, onUnmounted } from "vue";
  import { useDisplay } from "vuetify";
  const { lgAndUp } = useDisplay();
  import("@/styles/tailwind.css"); // Import

  // on mobile, fade between the two divs that contain content
  const fadeDiv = ref(0);
  const fadeDiv2 = ref(1);

  let interval;

  onMounted(() => {
    //only do this if it's on mobile
    if (lgAndUp.value === false) {
      interval = setInterval(() => {
        fadeDiv.value = fadeDiv.value === 0 ? 1 : 0;
        fadeDiv2.value = fadeDiv2.value === 0 ? 1 : 0;
      }, 3000);
    }
  });

  onUnmounted(() => {
    clearInterval(interval);
  });
</script>
<template>
  <a
    href="/register"
    class="marketing-toolbar fixed top-0 left-0 right-0 z-9999 bg-black text-white text-center"
  >
    <div class="max-w-7xl mx-auto justify-center items-center text-center inline-flex h-full relative w-full">
      <div
        class="mr-2 transition-opacity duration-500 h-full top-0 left-0 flex items-center justify-center"
        :class="fadeDiv && !lgAndUp ? 'opacity-0 absolute w-full' : 'opacity-100'"
      >
        <span class="font-bold hidden lg:block mr-2">Curiosity knows no limits – </span><span class="uppercase lg:lowercase">t</span>his
        month get unlimited access
      </div>
      <div
        class="transition-opacity duration-500 h-full top-0 left-0 flex items-center justify-center"
        :class="fadeDiv2 && !lgAndUp ? 'opacity-0 absolute w-full' : 'opacity-100'"
      >
        when you
        <v-btn
          color="white"
          variant="outlined"
          rounded
          size="small"
          class="ml-2 !h-auto !lowercase !px-2 !py-0.5 !text-[12px]"
          @click="router.push('/register')"
        >
          register for free
        </v-btn>
      </div>
    </div>
  </a>
</template>
<style>
  .marketing-toolbar {
    height: 28px;
    font-size: 13px;
  }

  #app,
  header.v-toolbar,
  .v-navigation-drawer__content {
    margin-top: 28px;
  }

  body .fixed-loader {
    margin-top: 92px !important;
  }
</style>
